import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {untrackedEvents} from 'src/openapi/admin/apis/SettingsControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import {getAccountId} from '../../../../services/selectors';
import {setupDataSelector} from '../services/selectors';

export const useUntrackedEvents = () => {
    const apiDispatch = useAppDispatch();
    const accountId = useSelector(getAccountId);
    const events = useSelector(setupDataSelector)?.untrackedEvents;

    const setEvents = useCallback((event: boolean) => {
        apiDispatch(untrackedEvents({accountId, untrackedEvents: event}));
    }, [accountId, apiDispatch]);

    return {events, setEvents};
};
